<template>
  <div class="content">
    <div class="order-sticky-scroll">
      <Navi class="order-sticky" tab-id="1" :form="form" />
      <form @submit.prevent="validate">
        <h2 class="page-title mb-4">引取・納車情報入力</h2>
        <div class="section-wrapper">
          <section id="order-place">
            <div class="row px-1 mx-0">
              <!-- 引取先 -->
              <div class="col-md-6 px-0 pr-md-2">
                <h4 class="_page-sub-title pl-2 pl-md-4 mb-1">
                  <div class="row">
                    <div class="col-5 pt-3">引取先</div>
                    <div class="col-7 text-right">
                      <md-button
                        class="md-primary md-raised history-btn"
                        @click="showDialog_trans = true"
                      >
                        履歴から選択
                      </md-button>
                    </div>
                  </div>
                </h4>
                <b-tabs content-class="bg-white mb-2 mb-sm-0" fill>
                  <b-tab
                    title="登録済みの場所"
                    @click="
                      changeActiveTab('HIKITORI', 'MASTER', form)
                      setHikitoriAaFlg('MASTER')
                    "
                    :active="form.HIKITORI_IS_MASTER_ACTIVE"
                  >
                    <Master
                      class="pt-2 pb-3 px-2 px-md-0"
                      ref="hikitori_master"
                      :is-search="hikitoriIsSearch.MASTER"
                      :is-valid="isHikitoriValid.MASTER"
                      :_search-cond="hikitoriSearchCond.MASTER"
                      :is-active="form.HIKITORI_IS_MASTER_ACTIVE"
                      :is-special-rate.sync="isSpecialRate.hiki"
                      @setData="onSelectedHikitori"
                      @reset="onHikitoriReset"
                      @setInvalid="onHikitoriInvalid"
                      @loaded="onHikitoriLoaded"
                      @searched="onHikitoriSearched"
                    />
                  </b-tab>
                  <b-tab
                    title="直接場所を指定"
                    @click="
                      specialRateAlert('hiki')
                      changeActiveTab('HIKITORI', 'DIRECT', form)
                      setHikitoriAaFlg('DIRECT')
                    "
                    :active="form.HIKITORI_IS_DIRECT_ACTIVE"
                  >
                    <Direct
                      class="p-md-2"
                      ref="hikitori_direct"
                      :is-search="hikitoriIsSearch.DIRECT"
                      :is-valid="isHikitoriValid.DIRECT"
                      :_search-cond="hikitoriSearchCond.DIRECT"
                      :is-get-aa-flg="isHikitoriGetAaFlg.DIRECT"
                      :is-okiniiri="form.isHikitoriOkiniiri"
                      :is-meihen="isMeihen"
                      :is-hikitori="true"
                      @setData="onSelectedHikitori"
                      @reset="onHikitoriReset"
                      @setInvalid="onHikitoriInvalid"
                      @setIsAAFlg="onHikitoriIsAAflg"
                      @setPosBango="onHikitoriPosBango"
                      @loaded="onHikitoriLoaded"
                      @searched="onHikitoriSearched"
                      @setIsOkiniiri="onHikitoriIsOkiniiri"
                    />
                  </b-tab>
                  <b-tab
                    title="お気に入りの場所"
                    @click="
                      changeActiveTab('HIKITORI', 'FAVORITE', form)
                      setHikitoriAaFlg('FAVORITE')
                    "
                    :active="form.HIKITORI_IS_FAVORITE_ACTIVE"
                  >
                    <Favorite
                      class="pt-2 pb-3 px-2 px-md-0"
                      ref="hikitori_okiniiri"
                      :is-search="hikitoriIsSearch.FAVORITE"
                      :is-valid="isHikitoriValid.FAVORITE"
                      :_search-cond="hikitoriSearchCond.FAVORITE"
                      :is-get-aa-flg="isHikitoriGetAaFlg.FAVORITE"
                      :is-meihen="isMeihen"
                      :is-active="form.HIKITORI_IS_FAVORITE_ACTIVE"
                      @setData="onSelectedHikitori"
                      @reset="onHikitoriReset"
                      @setInvalid="onHikitoriInvalid"
                      @setIsAAFlg="onHikitoriIsAAflg"
                      @loaded="onHikitoriLoaded"
                      @searched="onHikitoriSearched"
                    />
                  </b-tab>
                </b-tabs>
              </div>

              <div v-if="isMobile" class="text-center my-4 w-100">
                <button
                  type="button"
                  class="btn-lg btn-success exchange-btn md-raised"
                  @click="replaceHtoN"
                  :disabled="isHikinoLoading"
                >
                  <span>
                    <font-awesome-icon
                      icon="exchange-alt"
                      class="exchange-alt"
                      style="transform: rotate(90deg)"
                    />
                  </span>
                  <span class="ml-3">入力入替</span>
                </button>
              </div>

              <!-- 納車先 -->
              <div class="col-md-6 px-0 pl-md-2">
                <h4 class="_page-sub-title pl-2 pl-md-4 mb-1">
                  <div class="row">
                    <div class="col-5 pt-3">納車先</div>
                    <div class="col-7 text-right">
                      <md-button
                        class="md-primary md-raised history-btn"
                        @click="showDialog_trans = true"
                      >
                        履歴から選択
                      </md-button>
                    </div>
                  </div>
                </h4>
                <b-tabs content-class="bg-white" fill>
                  <b-tab
                    title="登録済みの場所"
                    @click="
                      changeActiveTab('NOSYA', 'MASTER', form)
                      setNosyaAaFlg('MASTER')
                    "
                    :active="form.NOSYA_IS_MASTER_ACTIVE"
                  >
                    <Master
                      class="pt-2 pb-3 px-2 px-md-0"
                      ref="nosya_master"
                      :is-search="nosyaIsSearch.MASTER"
                      :is-valid="isNosyaValid.MASTER"
                      :_search-cond="nosyaSearchCond.MASTER"
                      :is-active="form.NOSYA_IS_MASTER_ACTIVE"
                      :is-special-rate.sync="isSpecialRate.nosya"
                      @setData="onSelectedNosya"
                      @reset="onNosyaReset"
                      @setInvalid="onNosyaInvalid"
                      @loaded="onNosyaLoaded"
                      @searched="onNosyaSearched"
                    />
                  </b-tab>
                  <b-tab
                    title="直接場所を指定"
                    @click="
                      specialRateAlert('nosya')
                      changeActiveTab('NOSYA', 'DIRECT', form)
                      setNosyaAaFlg('DIRECT')
                    "
                    :active="form.NOSYA_IS_DIRECT_ACTIVE"
                  >
                    <Direct
                      class="p-md-2"
                      ref="nosya_direct"
                      :is-search="nosyaIsSearch.DIRECT"
                      :is-valid="isNosyaValid.DIRECT"
                      :_search-cond="nosyaSearchCond.DIRECT"
                      :is-get-aa-flg="isNosyaGetAaFlg.DIRECT"
                      :is-okiniiri="form.isNosyaOkiniiri"
                      :is-meihen="isMeihen"
                      @setData="onSelectedNosya"
                      @reset="onNosyaReset"
                      @setInvalid="onNosyaInvalid"
                      @setIsAAFlg="onNosyaIsAAflg"
                      @setPosBango="onNosyaPosBango"
                      @loaded="onNosyaLoaded"
                      @searched="onNosyaSearched"
                      @setIsOkiniiri="onNosyaIsOkiniiri"
                    />
                  </b-tab>
                  <b-tab
                    title="お気に入りの場所"
                    @click="
                      changeActiveTab('NOSYA', 'FAVORITE', form)
                      setNosyaAaFlg('FAVORITE')
                    "
                    :active="form.NOSYA_IS_FAVORITE_ACTIVE"
                  >
                    <Favorite
                      class="pt-2 pb-3 px-2 px-md-0"
                      ref="nosya_okiniiri"
                      :is-search="nosyaIsSearch.FAVORITE"
                      :is-valid="isNosyaValid.FAVORITE"
                      :_search-cond="nosyaSearchCond.FAVORITE"
                      :is-get-aa-flg="isNosyaGetAaFlg.FAVORITE"
                      :is-meihen="isMeihen"
                      :is-active="form.NOSYA_IS_FAVORITE_ACTIVE"
                      @setData="onSelectedNosya"
                      @reset="onNosyaReset"
                      @setInvalid="onNosyaInvalid"
                      @setIsAAFlg="onNosyaIsAAflg"
                      @loaded="onNosyaLoaded"
                      @searched="onNosyaSearched"
                    />
                  </b-tab>
                  <b-tab
                    v-if="isMeihen && isLease"
                    title="引取先と同じ"
                    @click="
                      changeActiveTab('NOSYA', 'SAME', form)
                      form.NOSYA_AA_FLG = form.HIKITORI_AA_FLG
                    "
                    :active="form.NOSYA_IS_SAME_ACTIVE"
                  >
                    <div class="bg-white text-center py-3">
                      引取先と同じ住所を指定します。
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
            <div v-if="!isMobile" class="text-center my-2 mt-md-3">
              <button
                type="button"
                class="btn-lg btn-success exchange-btn md-raised"
                @click="replaceHtoN()"
                :disabled="isHikinoLoading || isNosyaSame"
              >
                <span>
                  <font-awesome-icon icon="exchange-alt" class="exchange-alt" />
                </span>
                <span class="ml-3">入力入替</span>
              </button>
            </div>
          </section>
        </div>

        <hiki-no-detail
          :_form="form"
          :is-set-data="isSetHikiNoDetail"
          :is-get-data="isGetHikiNoDetail"
          :is-hikitori-a-a="isHikitoriAA"
          :is-nosya-a-a="isNosyaAA"
          :hiki-aa-cd="selectedHikiAaCd"
          :nosya-aa-cd="selectedNosyaAaCd"
          @setInvalid="onSetHikiNoDetail"
        />

        <div class="text-center mr-3 mr-md-0 my-3 mb-5">
          <md-button
            type="button"
            class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
            :to="{ name: 'OrderIndex' }"
          >
            もどる
          </md-button>
          <br v-if="isMobile" />
          <md-button
            type="submit"
            class="btn-lg btn-success base-btn col-md-3 col-lg-2"
            :disabled="isHikinoLoading"
          >
            次へ
          </md-button>
        </div>
      </form>

      <!-- 履歴モーダル -->
      <md-dialog
        :md-active.sync="showDialog_trans"
        class="new w-800"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
      >
        <md-dialog-title>履歴選択</md-dialog-title>
        <div class="px-3 p-md-4">
          <div class="ml-md-3 mb-3 search-wrapper">
            <div>
              <label
                class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0"
              >
                所在地
              </label>
              <div class="d-md-inline text-left">
                <select
                  class="d-inline form-control col-4 col-md-2 ml-md-2"
                  @change="changePref('RIREKI')"
                  v-model="form.RIREKI_TODO_CD"
                >
                  <option
                    v-for="pref in prefs"
                    :value="pref.TODO_CD"
                    :key="pref.TODO_CD"
                  >
                    {{ pref.TODO_MEI }}
                  </option>
                </select>
                <select
                  class="d-inline form-control col-7 col-md-3 ml-2"
                  @change="changeCity('RIREKI')"
                  v-model="form.RIREKI_SHIKU_CD"
                  :disabled="!cities.RIREKI.length"
                >
                  <option
                    v-for="city in cities.RIREKI"
                    :value="city.SHIKU_CD"
                    :key="city.SHIKU_CD"
                  >
                    {{ city.SHIKU_MEI }}
                  </option>
                </select>
              </div>
              <label
                class="
                  d-md-inline
                  pt-2
                  col-md-4 col-lg-2
                  text-left
                  px-0
                  my-0
                  ml-md-4
                "
              >
                引取/納車
              </label>
              <select
                class="d-md-inline form-control col-4 col-md-2 ml-md-2"
                v-model="form.RIREKI_TYPE"
                @change="changeType('RIREKI')"
              >
                <option value="hn">両方</option>
                <option value="h">引取先</option>
                <option value="n">納車先</option>
              </select>
            </div>
          </div>

          <section id="order-rireki">
            <div v-if="async.rireki" class="spinner my-5">
              <md-progress-spinner md-mode="indeterminate" />
            </div>
            <div v-else>
              <md-table
                v-if="rireki.length"
                class="black-svg h-300 checkbox"
                v-model="rireki"
                md-card
                md-fixed-header
              >
                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  @click="selectRireki(item)"
                  :class="['text-left', getTableRowClass(item)]"
                >
                  <md-table-cell
                    v-if="!isMobile"
                    :class="getTableRowClass(item)"
                    md-label=""
                  >
                    <input
                      type="radio"
                      :id="item.id"
                      :value="item.id"
                      name="exampleRadios"
                      v-model="picked"
                    />
                  </md-table-cell>

                  <md-table-cell md-label="引取先名" md-sort-by="torihikiName">
                    <span v-if="!isMobile">
                      {{ omitText(item.HIKITORI_MEI, 20) }}
                    </span>
                    <div v-else class="row">
                      <p class="col-4 p-0 bold">引取先名</p>
                      <p class="col-8 p-0">
                        {{ _omitText(item.HIKITORI_MEI, 18) }}
                      </p>
                    </div>
                  </md-table-cell>

                  <md-table-cell
                    md-label="引取先住所"
                    md-sort-by="torihikiAddress"
                  >
                    <span v-if="!isMobile">
                      {{ omitText(item.HIKITORI_ADDRESS, 20) }}
                    </span>
                    <div v-else class="row">
                      <p class="col-4 p-0 bold">引取先住所</p>
                      <p class="col-8 p-0">
                        {{ _omitText(item.HIKITORI_ADDRESS, 18) }}
                      </p>
                    </div>
                  </md-table-cell>

                  <md-table-cell md-label="納車先名" md-sort-by="nosyaName">
                    <span v-if="!isMobile">
                      {{ omitText(item.NOSYA_MEI, 20) }}
                    </span>
                    <div v-else class="row">
                      <p class="col-4 p-0 bold">納車先名</p>
                      <p class="col-8 p-0">
                        {{ _omitText(item.NOSYA_MEI, 18) }}
                      </p>
                    </div>
                  </md-table-cell>

                  <md-table-cell
                    md-label="納車先住所"
                    md-sort-by="nosyaAddress"
                  >
                    <span v-if="!isMobile">
                      {{ omitText(item.NOSYA_ADDRESS, 20) }}
                    </span>
                    <div v-else class="row">
                      <p class="col-4 p-0 bold">納車先住所</p>
                      <p class="col-8 p-0">
                        {{ _omitText(item.NOSYA_ADDRESS, 18) }}
                      </p>
                    </div>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <div v-else class="text-center my-5 bold">
                該当データがありません。
              </div>
            </div>
          </section>
          <md-dialog-actions>
            <md-button class="md-primary" @click="showDialog_trans = false">
              閉じる
            </md-button>
            <md-button class="md-primary" @click="makeHikino">決定</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>
    </div>

    <!-- 新規申し込み -->
    <md-dialog
      :md-active.sync="activeSavedPosModal"
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>POS新規登録確認</md-dialog-title>
      <div class="p-2 p-md-offset modal-content">
        <div class="pt-md-3 text-center">
          <div>入力されているPOSを新たに登録しますか？</div>
          <div class="btn-wrapper row mt-3">
            <p class="col-6">
              <md-button type="button" @click="gotoNext">
                登録せずに次へ
              </md-button>
            </p>
            <p class="col-6">
              <md-button
                type="button"
                @click="addPos"
                :disabled="!activeSavedPosModal"
              >
                登録して次へ&emsp;
              </md-button>
            </p>
          </div>
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="activeSavedPosModal = false">
          閉じる
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isShowSpecialRateAlert"
      md-content="<strong>お客様用の特別料金を適用するには「登録済みの場所」から住所を選択してください</strong>"
    />
  </div>
</template>

<script>
import HikiNoDetail from '@/components/order/HikiNoDetail'
import Store from '@/store/index.js'
import _ from 'lodash'
import Mixin from '../mixin/Mixin'
import Direct from './Direct'
import Favorite from './Favorite'
import Master from './Master'
import Navi from './Navi'

const HIKINO_SAKI = {
  AA_KAISAI_BI: null,
  YUBIN1: null,
  YUBIN2: null,
  TODO_CD: null,
  TODO_MEI: null,
  SHIKU_CD: null,
  SHIKU_MEI: null,
  BANCHI: null,
  MEI: null,
  TEL: null,
  FAX: null,
  TANTO_MEI: null,
  TANTO_TEL: null,
  TANTO_FAX: null,
  YUSO_KBN: null,
  HCB_ZOKUSEI_CD: null,
  LANDMARK_KBN: null,
  TEIKYU_BI: null,
  EIGYO_KAISI_JIKAN: null,
  EIGYO_SYURYO_JIKAN: null,
  TOROKUBAYO_KO_ID: null,
  HANNYUSYUTU_JIKAN: null,
  AA_ID: null,
  AA_CD: null,
  FAVORITE_ID: null,
}
export default {
  name: 'OrderIndex',
  mixins: [Mixin],
  components: {
    Navi,
    Master,
    Direct,
    Favorite,
    History,
    HikiNoDetail,
  },
  data: () => ({
    /** 引納詳細情報設定フラグ */
    isSetHikiNoDetail: false,

    /** 引納詳細情報取得フラグ */
    isGetHikiNoDetail: false,

    /** 引納詳細情報入力エラーフラグ */
    isHikiNoDetailInvalid: false,

    /** 引取オークションフラグ取得イベントフラグ */
    isHikitoriGetAaFlg: {
      DIRECT: false,
      FAVORITE: false,
    },

    /** 引取オークションフラグ取得イベントフラグ */
    isNosyaGetAaFlg: {
      DIRECT: false,
      FAVORITE: false,
    },

    /** 引取先検索実行フラグ */
    hikitoriIsSearch: {
      MASTER: false,
      DIRECT: false,
      FAVORITE: false,
    },

    /**
     * 引取先の初期値を再現するための条件
     * 編集時、料金検索からの遷移時に利用
     */
    hikitoriSearchCond: {
      MASTER: null,
      DIRECT: {
        other: null,
        aa: null,
      },
      FAVORITE: null,
    },

    /** 引取ローディングフラグ */
    hikitoriIsLoading: {
      MASTER: false,
      DIRECT: false,
      FAVORITE: false,
    },

    /** 引取バリデーション実行フラグ */
    isHikitoriValid: {
      MASTER: false,
      DIRECT: false,
      FAVORITE: false,
    },

    /** 引取バリデーション結果 */
    hikitoriInvalid: {
      MASTER: true,
      DIRECT: true,
      FAVORITE: true,
    },

    /** 納車先検索実行フラグ */
    nosyaIsSearch: {
      MASTER: false,
      DIRECT: false,
      FAVORITE: false,
    },

    /**
     * 納車先の初期値を再現するための条件
     * 編集時、料金検索からの遷移時に利用
     */
    nosyaSearchCond: {
      MASTER: null,
      DIRECT: {
        other: null,
        aa: null,
      },
      FAVORITE: null,
    },

    /** 納車ローディングフラグ */
    nosyaIsLoading: {
      MASTER: false,
      DIRECT: false,
      FAVORITE: false,
    },

    /** 納車バリデーション実行フラグ */
    isNosyaValid: {
      MASTER: false,
      DIRECT: false,
      FAVORITE: false,
    },

    /** 納車バリデーション結果 */
    nosyaInvalid: {
      MASTER: true,
      DIRECT: true,
      FAVORITE: true,
    },

    async: {
      rireki: false,
    },
    cities: {
      // 市区町村配列
      RIREKI: [],
    },

    form: {
      RIREKI_TODO_CD: null,
      RIREKI_SHIKU_CD: null,
      RIREKI_TYPE: 'hn',

      // どのタブを選択しているか
      ACTIVE_HIKITORI_TAB: 'MASTER',
      ACTIVE_NOSYA_TAB: 'MASTER',
      HIKITORI_IS_MASTER_ACTIVE: true,
      HIKITORI_IS_DIRECT_ACTIVE: false,
      HIKITORI_IS_FAVORITE_ACTIVE: false,
      NOSYA_IS_MASTER_ACTIVE: true,
      NOSYA_IS_DIRECT_ACTIVE: false,
      NOSYA_IS_FAVORITE_ACTIVE: false,
      NOSYA_IS_SAME_ACTIVE: false,

      /** 引取先登録済み入力データ */
      HIKITORI_MASTER: _.cloneDeep(HIKINO_SAKI),

      /** 引取先直接入力データ */
      HIKITORI_DIRECT: _.cloneDeep(HIKINO_SAKI),

      /** 引取先オークション入力データ */
      HIKITORI_AUCTION: _.cloneDeep(HIKINO_SAKI),

      /** 引取先お気に入り入力データ */
      HIKITORI_FAVORITE: _.cloneDeep(HIKINO_SAKI),

      /** 引取オークションフラグ */
      HIKITORI_AA_FLG: 0,

      /** 納車先登録済み入力データ */
      NOSYA_MASTER: _.cloneDeep(HIKINO_SAKI),

      /** 納車先直接入力データ */
      NOSYA_DIRECT: _.cloneDeep(HIKINO_SAKI),

      /** 納車先オークション入力データ */
      NOSYA_AUCTION: _.cloneDeep(HIKINO_SAKI),

      /** 納車先お気に入り入力データ */
      NOSYA_FAVORITE: _.cloneDeep(HIKINO_SAKI),

      /** 納車オークションフラグ */
      NOSYA_AA_FLG: 0,

      // 共通の引納情報
      JYUCYU_SHIKI_CD: null,
      HUM_TANTO_ID: null,
      MEIHEN_FLG: null,
      HIKITORI_AA_WANPULA_FLG: null,
      HIKITORI_AA_WANPULA_RAKUSATU_BI: null,
      HIKITORI_AA_RYUSATU_SYARYO: null,
      HIKITORI_AA_POS_BANGO: null,
      HIKITORI_AA_POS_DETAIL_ID: null,
      HIKITORI_AA_POS_KBN: 1,
      HIKITORI_AA_POS_RAKUSATU_SYUPPIN: 0,
      HIKITORI_AA_POS_DAIKO_GYOSHA_MEI: null,
      HIKITORI_AA_POS_MEIGI_INFO: null,
      HIKITORI_AA_NYUKIN_JYOKYO_KBN: '',
      HIKITORI_AA_NYUKIN_YOTEI_BI: null,
      HIKITORI_AA_NYUKIN_YOTEI_JIKAN: '',
      HIKITORI_AA_KAISAI_BI: null,
      HANSYUTU_KIBOU_BI: null,
      HANSYUTU_JIZEN_RENRAKU_FLG: 0,
      HIKITORI_BIKOU: null,
      NOSYA_AA_POS_BANGO: null,
      NOSYA_AA_POS_DETAIL_ID: null,
      NOSYA_AA_POS_KBN: 1,
      NOSYA_AA_POS_RAKUSATU_SYUPPIN: 0,
      NOSYA_AA_POS_DAIKO_GYOSHA_MEI: null,
      NOSYA_AA_POS_MEIGI_INFO: null,
      NOSYA_AA_SYUPPIN_MEI: null,
      NOSYA_AA_KAIJYO_TANTO_MEI: null,
      NOSYA_AA_KAISAI_BI: null,
      HANNYU_KIBOU_BI: null,
      HANNYU_JIZEN_RENRAKU_FLG: 0,
      NOSYA_BIKOU: null,
      JYUCYU_BIKO: null,
      SKS_DIRECT_FLG: 0,
      SKS_KAISYA: null,
      SKS_BUSYO: null,
      SKS_YUBIN1: null,
      SKS_YUBIN2: null,
      SKS_TODO: null,
      SKS_TODO_CD: null,
      SKS_JYUSYO1: null,
      SKS_JYUSYO_CD: '',
      SKS_SHIKU_MEI: null,
      SKS_TEL: null,
      SKS_FAX: null,
      SKS_MAIL_ADDR: null,
      SKS_TANTO_MEI: null,
      SKS_TANTO_MEI_SEI: null,
      SKS_IS_FAVORITE_SAVE: 0,

      /** 引取お気に入りフラグ */
      isHikitoriOkiniiri: false,

      /** 納車お気に入りフラグ */
      isNosyaOkiniiri: false,

      /** 納車タブが引取先と同じを選択したかフラグ */
      isNosyaSame: false,
    },

    /** 履歴や編集時の対象データ */
    selectedItem: null,

    rireki: [],
    showDialog_trans: false,

    // 引取先選択オークションコード
    selectedHikiAaCd: null,

    // 納車先選択オークションコード
    selectedNosyaAaCd: null,

    // pos新規登録確認ダイアログ表示フラグ
    activeSavedPosModal: false,

    /** 次へに行くときに保存するPOSデータ */
    savedPosList: [],

    /** 登録済みの場所に特別料金が存在するか */
    isSpecialRate: {
      hiki: false,
      nosya: false,
    },

    /** 特別料金のアラート表示フラグ */
    isShowSpecialRateAlert: false,
  }),

  computed: {
    /** 引取先にバリデーションエラーがあるか */
    isHikitoriInvalid() {
      return this.hikitoriInvalid[this.form.ACTIVE_HIKITORI_TAB]
    },

    /** 納車先にバリデーションエラーがあるか */
    isNosyaInvalid() {
      return this.nosyaInvalid[this.form.ACTIVE_NOSYA_TAB]
    },

    /** 引納先がLoadign中か */
    isHikinoLoading() {
      return (
        this.hikitoriIsLoading.MASTER ||
        this.hikitoriIsLoading.DIRECT ||
        this.hikitoriIsLoading.FAVORITE ||
        this.nosyaIsLoading.MASTER ||
        this.nosyaIsLoading.DIRECT ||
        this.nosyaIsLoading.FAVORITE
      )
    },

    /** 引取オークション表示フラグ */
    isHikitoriAA() {
      return Number(!this.isLease && this.form.HIKITORI_AA_FLG)
    },

    /** 納車オークション表示フラグ */
    isNosyaAA() {
      return Number(!this.isLease && this.form.NOSYA_AA_FLG)
    },

    /** 名変輸送か判定 */
    isMeihen() {
      return this.form.MEIHEN_FLG
    },

    /** 納車先が引取先と同じタブか */
    isNosyaSame() {
      return this.form.ACTIVE_NOSYA_TAB === 'SAME'
    },
  },

  methods: {
    /** デフォルトformと指定formをマージする */
    formDefaultMerge(form) {
      let d = {}
      for (const name in form) {
        if (form[name] !== null) d[name] = form[name]
        else if (this.form[name] !== undefined) d[name] = this.form[name]
      }
      for (const name in this.form) {
        if (form[name] === undefined) d[name] = this.form[name]
      }
      return d
    },

    /** バリデーション */
    async validate() {
      // 引納先のバリデーションを手動実行
      const hTab = this.form.ACTIVE_HIKITORI_TAB
      let nTab = this.form.ACTIVE_NOSYA_TAB
      this.isHikitoriValid[hTab] = true
      if (!this.isNosyaSame) this.isNosyaValid[nTab] = true
      this.isGetHikiNoDetail = true
      await this.sleep(100)

      if (
        this.isHikiNoDetailInvalid ||
        this.isHikitoriInvalid ||
        this.isNosyaInvalid
      ) {
        this._alert('入力項目にエラーがあります。')
        return
      }

      // 引取先と同じ(法人の場合)
      if (this.isNosyaSame) {
        this.copyHtoN()
        this.form.isNosyaSame = true
        this.form.ACTIVE_NOSYA_TAB = hTab
        nTab = hTab
      }

      // posユニークチェック
      this.savedPosList = []
      if (!this.isLease) {
        this.spinerOn()
        let apiList = []
        const hikiActive =
          hTab === 'DIRECT' && this.form.HIKITORI_AA_FLG ? 'AUCTION' : hTab
        const nosyaActive =
          nTab === 'DIRECT' && this.form.NOSYA_AA_FLG ? 'AUCTION' : nTab
        const hikiAaCd = this.form[`HIKITORI_${hikiActive}`].AA_CD
        const nosyaAaCd = this.form[[`NOSYA_${nosyaActive}`]].AA_CD
        if (hikiAaCd && this.form.HIKITORI_AA_POS_KBN !== 3) {
          apiList.push(this.checkDuplicatePos(hikiAaCd, 'HIKITORI'))
        }
        if (nosyaAaCd && this.form.NOSYA_AA_POS_KBN !== 3) {
          apiList.push(this.checkDuplicatePos(nosyaAaCd, 'NOSYA'))
        }

        if (apiList.length) {
          await Promise.all(apiList).then((res) => {
            res
              .filter((v) => !v.value)
              .map((v2) => {
                if (v2.name === 'HIKITORI')
                  this.savedPosList.push(
                    this.makeSavedPosData(hikiAaCd, v2.name)
                  )
                if (v2.name === 'NOSYA')
                  this.savedPosList.push(
                    this.makeSavedPosData(nosyaAaCd, v2.name)
                  )
              })
          })
        }
      }
      if (this.savedPosList.length) this.activeSavedPosModal = true
      else this.gotoNext()
      this.spinerOff()
    },

    /** 登録するPOSデータを生成する */
    makeSavedPosData(aaCd, hikiNoName) {
      return {
        ID: null,
        JYUCYU_SHIKI_CD: Store.state.user.data.JYUCYU_SHIKI_CD,
        AA_CD: aaCd,
        POS_BANGO: this.form[`${hikiNoName}_AA_POS_BANGO`],
        pos_detail: [
          {
            ID: null,
            RAKUSATU_SYUPPIN: hikiNoName == 'HIKITORI' ? 2 : 1,
            POS_KBN: this.form[`${hikiNoName}_AA_POS_KBN`],
            DAIKO_GYOSHA_MEI:
              this.form[`${hikiNoName}_AA_POS_DAIKO_GYOSHA_MEI`],
            MEIGI_INFO: this.form[`${hikiNoName}_AA_POS_MEIGI_INFO`],
          },
        ],
      }
    },

    /** 入力したPOSと重複するデータがないか */
    checkDuplicatePos(aaCd, hikiNoName) {
      const cond = {
        JYUCYU_SHIKI_CD: Store.state.user.data.JYUCYU_SHIKI_CD,
        AA_CD: aaCd,
        POS_BANGO: this.form[`${hikiNoName}_AA_POS_BANGO`],
        POS_KBN: this.form[`${hikiNoName}_AA_POS_KBN`],
        RAKUSATU_SYUPPIN: hikiNoName == 'HIKITORI' ? 2 : 1,
        DAIKO_GYOSHA_MEI: this.form[`${hikiNoName}_AA_POS_DAIKO_GYOSHA_MEI`],
        MEIGI_INFO: this.form[`${hikiNoName}_AA_POS_MEIGI_INFO`],
      }
      return this.$store
        .dispatch('order/getPos', { cond: cond })
        .then((res) => {
          return { name: hikiNoName, value: res.length > 0 }
        })
    },

    /** 新規POSを登録する */
    async addPos() {
      this.activeSavedPosModal = false
      this.spinerOn()
      // TODO 二重実行を防止するための配列。根本的には二重実行される状況を防ぐ必要がある
      let rakusatuSyuppins = []
      const apiList = this.savedPosList
        .filter((v) => {
          const rakusatuSyuppin = v.pos_detail[0].RAKUSATU_SYUPPIN
          const result = !rakusatuSyuppins.includes(rakusatuSyuppin)
          rakusatuSyuppins.push(rakusatuSyuppin)
          return result
        })
        .map((pos) => this.$store.dispatch('order/updatePos', pos))
      await Promise.all(apiList)
        .then((res) => this.gotoNext())
        .catch((err) =>
          this._alert('POS登録でエラーが発生いたしました。', false)
        )
      this.spinerOff()
    },

    /** 次画面に遷移する */
    gotoNext() {
      this.activeSavedPosModal = false
      this.$router.push({
        name: this.isMeihen ? 'OrderMeihenVehicle' : 'OrderVehicle',
        params: { form: this.form },
      })
    },

    /**
     * 引納種別選択時処理
     */
    async changeType(paramName) {
      this.getRireki(
        this.form.HUM_TANTO_ID,
        this.form[`${paramName}_TODO_CD`],
        this.form[`${paramName}_SHIKU_CD`],
        this.form[`${paramName}_TYPE`]
      )
    },

    /** 入替処理 */
    async replaceHtoN() {
      // データ入替
      const replace = true
      this.setHikino(replace)
      this.hikinoSearch()

      this.form.HIKITORI_AA_FLG = 0
      this.form.NOSYA_AA_FLG = 0

      // オークション情報
      const posInfoColumnShufix = [
        'BANGO',
        'DETAIL_ID',
        'KBN',
        'RAKUSATU_SYUPPIN',
        'DAIKO_GYOSHA_MEI',
      ]
      posInfoColumnShufix.forEach((columnShufix) => {
        const hFormColumn = `HIKITORI_AA_POS_${columnShufix}`
        const nFormColumn = `NOSYA_AA_POS_${columnShufix}`
        const hAaPosValue = this.form[hFormColumn]
        this.form[hFormColumn] = this.form[nFormColumn]
        this.form[nFormColumn] = hAaPosValue
      })

      // タブ切り替え
      const hTab = this.form.ACTIVE_HIKITORI_TAB
      const nTab = this.form.ACTIVE_NOSYA_TAB
      this.changeActiveTab('HIKITORI', nTab, this.form)
      this.changeActiveTab('NOSYA', hTab, this.form)
    },

    /** 引納先検索実行 */
    hikinoSearch() {
      this.hikitoriIsSearch.MASTER = true
      this.hikitoriIsSearch.DIRECT = true
      this.hikitoriIsSearch.FAVORITE = true
      this.nosyaIsSearch.MASTER = true
      this.nosyaIsSearch.DIRECT = true
      this.nosyaIsSearch.FAVORITE = true
    },

    /** 引納データをセットする */
    setHikino(isReplace = false) {
      const f = _.cloneDeep(this.form)
      const hMaster = isReplace ? f.NOSYA_MASTER : f.HIKITORI_MASTER
      const hDirect = isReplace ? f.NOSYA_DIRECT : f.HIKITORI_DIRECT
      const hAA = isReplace ? f.NOSYA_AUCTION : f.HIKITORI_AUCTION
      const hFav = isReplace ? f.NOSYA_FAVORITE : f.HIKITORI_FAVORITE
      const hAaFlg = isReplace
        ? this.form.NOSYA_AA_FLG
        : this.form.HIKITORI_AA_FLG

      const nMaster = isReplace ? f.HIKITORI_MASTER : f.NOSYA_MASTER
      const nDirect = isReplace ? f.HIKITORI_DIRECT : f.NOSYA_DIRECT
      const nAA = isReplace ? f.HIKITORI_AUCTION : f.NOSYA_AUCTION
      const nFav = isReplace ? f.HIKITORI_FAVORITE : f.NOSYA_FAVORITE
      const nAaFlg = isReplace
        ? this.form.HIKITORI_AA_FLG
        : this.form.NOSYA_AA_FLG

      this.hikitoriSearchCond = {
        MASTER: this.getSearchCondMaster(hMaster),
        DIRECT: this.getSearchCondDirect(hDirect, hAA, hAaFlg),
        FAVORITE: this.getSearchCondFavorite(hFav),
      }
      this.nosyaSearchCond = {
        MASTER: this.getSearchCondMaster(nMaster),
        DIRECT: this.getSearchCondDirect(nDirect, nAA, nAaFlg),
        FAVORITE: this.getSearchCondFavorite(nFav),
      }
    },

    /** 引取先登録済みの場所を設定する条件を返却 */
    getSearchCondMaster(item) {
      return {
        ID: item.TOROKUBAYO_KO_ID,
        TODO_CD: item.TODO_CD,
        SHIKU_CD: item.SHIKU_CD,
      }
    },

    /** お気に入りの場所を設定する条件を返却 */
    getSearchCondFavorite(item) {
      return {
        ID: item.FAVORITE_ID,
        TODO_CD: item.TODO_CD,
        SHIKU_CD: item.SHIKU_CD,
      }
    },

    /** 直接入力を設定する条件を返却 */
    getSearchCondDirect(other, aa, isAAFlg) {
      return {
        isAAFlg: isAAFlg,
        other: other,
        aa: { AA_ID: aa.AA_ID, AA_CD: aa.AA_CD, TODO_CD: aa.TODO_CD },
      }
    },

    /** 編集データを設定する */
    setEdit(item) {
      this.selectedItem = _.cloneDeep(item)
      this.makeHikino()
      this.form.HANNYU_JIZEN_RENRAKU_FLG = item.HANNYU_JIZEN_RENRAKU_FLG || 0
      this.form.HANNYU_KIBOU_BI = item.HANNYU_KIBOU_BI || null
      this.form.HANSYUTU_JIZEN_RENRAKU_FLG =
        item.HANSYUTU_JIZEN_RENRAKU_FLG || 0
      this.form.HANSYUTU_KIBOU_BI = item.HANSYUTU_KIBOU_BI || null
      this.form.HIKITORI_AA_ID = item.HIKITORI_AA_ID || null
      this.form.HIKITORI_AA_CD = item.HIKITORI_AA_CD || null
      this.form.HIKITORI_AA_KAISAI_BI = item.HIKITORI_AA_KAISAI_BI || null
      this.form.HIKITORI_AA_NYUKIN_JYOKYO_KBN =
        item.HIKITORI_AA_NYUKIN_JYOKYO_KBN || ''
      this.form.HIKITORI_AA_NYUKIN_YOTEI_BI =
        item.HIKITORI_AA_NYUKIN_YOTEI_BI || null
      this.form.HIKITORI_AA_NYUKIN_YOTEI_JIKAN =
        item.HIKITORI_AA_NYUKIN_YOTEI_JIKAN || ''
      this.form.HIKITORI_AA_POS_BANGO = item.HIKITORI_AA_POS_BANGO || null
      this.form.HIKITORI_AA_POS_DETAIL_ID =
        item.HIKITORI_AA_POS_DETAIL_ID || null
      this.form.HIKITORI_AA_POS_KBN = item.HIKITORI_AA_POS_KBN || 1
      this.form.HIKITORI_AA_POS_RAKUSATU_SYUPPIN =
        item.HIKITORI_AA_POS_RAKUSATU_SYUPPIN || 0
      this.form.HIKITORI_AA_POS_DAIKO_GYOSHA_MEI =
        item.HIKITORI_AA_POS_DAIKO_GYOSHA_MEI || null
      this.form.HIKITORI_AA_POS_MEIGI_INFO =
        item.HIKITORI_AA_POS_MEIGI_INFO || null
      this.form.HIKITORI_AA_WANPULA_FLG = item.HIKITORI_AA_WANPULA_FLG || null
      this.form.HIKITORI_AA_WANPULA_RAKUSATU_BI =
        item.HIKITORI_AA_WANPULA_RAKUSATU_BI || null
      this.form.HIKITORI_AA_RYUSATU_SYARYO =
        item.HIKITORI_AA_RYUSATU_SYARYO || null
      this.form.HIKITORI_BIKOU = item.HIKITORI_BIKOU || null
      this.form.HIKITORI_FAX = item.HIKITORI_FAX || null
      this.form.HIKITORI_TANTO_FAX = item.HIKITORI_TANTO_FAX || null
      this.form.HUM_TANTO_ID = item.HUM_TANTO_ID || null
      this.form.NOSYA_AA_ID = item.NOSYA_AA_ID || null
      this.form.NOSYA_AA_CD = item.NOSYA_AA_CD || null
      this.form.NOSYA_AA_KAISAI_BI = item.NOSYA_AA_KAISAI_BI || null
      this.form.NOSYA_AA_KAIJYO_TANTO_MEI =
        item.NOSYA_AA_KAIJYO_TANTO_MEI || null
      this.form.NOSYA_AA_POS_BANGO = item.NOSYA_AA_POS_BANGO || null
      this.form.NOSYA_AA_POS_DETAIL_ID = item.NOSYA_AA_POS_DETAIL_ID || null
      this.form.NOSYA_AA_POS_KBN = item.NOSYA_AA_POS_KBN || 1
      this.form.NOSYA_AA_POS_RAKUSATU_SYUPPIN =
        item.NOSYA_AA_POS_RAKUSATU_SYUPPIN || 0
      this.form.NOSYA_AA_POS_DAIKO_GYOSHA_MEI =
        item.NOSYA_AA_POS_DAIKO_GYOSHA_MEI || null
      this.form.NOSYA_AA_POS_MEIGI_INFO = item.NOSYA_AA_POS_MEIGI_INFO || null
      this.form.NOSYA_AA_SYUPPIN_MEI = item.NOSYA_AA_SYUPPIN_MEI || null
      this.form.NOSYA_BIKOU = item.NOSYA_BIKOU || null
      this.form.NOSYA_FAX = item.NOSYA_FAX || null
      this.form.NOSYA_TANTO_FAX = item.NOSYA_TANTO_FAX || null
      this.form.SKS_BUSYO = item.SKS_BUSYO || null
      this.form.SKS_DIRECT_FLG = item.SKS_DIRECT_FLG || 0
      this.form.SKS_FAX = item.SKS_FAX || null
      this.form.SKS_JYUSYO1 = item.SKS_JYUSYO1 || null
      this.form.SKS_JYUSYO_CD = item.SKS_JYUSYO_CD || null
      this.form.SKS_KAISYA = item.SKS_KAISYA || null
      this.form.SKS_TANTO_MEI = item.SKS_TANTO_MEI || null
      this.form.SKS_TEL = item.SKS_TEL || null
      this.form.SKS_TODO = item.SKS_TODO || null
      this.form.SKS_TODO_CD = item.SKS_TODO_CD || null
      this.form.SKS_YUBIN1 = item.SKS_YUBIN1 || null
      this.form.SKS_YUBIN2 = item.SKS_YUBIN2 || null
    },

    /**
     * 履歴リスト
     * @param {String} tantoId   担当ID
     */
    getRireki(tantoId = null, prefCd = null, cityCd = null, type = null) {
      this.async.rireki = true
      return this.$store
        .dispatch('order/getJyucyu', { tantoId, prefCd, cityCd, type })
        .then((res) => {
          this.rireki = res.data
          this.async.rireki = false
        })
        .catch((err) => {
          this.async.rireki = false
          this._alert(err.message, false)
        })
    },

    /** 履歴選択 */
    selectRireki(item) {
      this.setTableRowClassAndName(item.id, this.rireki)
      this.selectedItem = item
    },

    /** 引納先データを生成し描画する */
    async makeHikino() {
      /** 引取納車先設定 */
      const setData = (item, hikino, tab) => {
        let data = {
          AA_KAISAI_BI: item[`${hikino}_AA_KAISAI_BI`],
          YUBIN1: item[`${hikino}_YUBIN1`],
          YUBIN2: item[`${hikino}_YUBIN2`],
          TODO_CD: item[`${hikino}_TODO_CD`],
          TODO_MEI: item[`${hikino}_TODO_MEI`],
          SHIKU_CD: item[`${hikino}_SHIKU_CD`],
          SHIKU_MEI: item[`${hikino}_SHIKU_MEI`],
          BANCHI: item[`${hikino}_BANCHI`],
          MEI: item[`${hikino}_MEI`],
          TEL: item[`${hikino}_TEL`],
          FAX: item[`${hikino}_FAX`],
          TANTO_MEI: item[`${hikino}_TANTO_MEI`],
          TANTO_TEL: item[`${hikino}_TANTO_TEL`],
          TANTO_FAX: item[`${hikino}_TANTO_FAX`],
          YUSO_KBN: item[`${hikino}_YUSO_KBN`],
          HCB_ZOKUSEI_CD: item[`${hikino}_HCB_ZOKUSEI_CD`],
          LANDMARK_KBN: item[`${hikino}_LANDMARK_KBN`],
          TEIKYU_BI: [],
          EIGYO_KAISI_JIKAN: item[`${hikino}_EIGYO_KAISI_JIKAN`],
          EIGYO_SYURYO_JIKAN: item[`${hikino}_EIGYO_SYURYO_JIKAN`],
          TOROKUBAYO_KO_ID: null,
          HANNYUSYUTU_JIKAN: item[`${hikino}_HANNYUSYUTU_JIKAN`],
          AA_ID: null,
          AA_CD: item[`${hikino}_AA_CD`],
          FAVORITE_ID: null,
        }
        // 定休日設定
        if (item[`${hikino}_TEIKYU_BI`]) {
          data.TEIKYU_BI =
            tab === 'DIRECT'
              ? item[`${hikino}_TEIKYU_BI`].split(',')
              : item[`${hikino}_TEIKYU_BI`]
        }
        return data
      }

      /** タブ名 */
      const tabName = {
        torokubasyo: 'MASTER',
        direct: 'DIRECT',
        okiniiri: 'FAVORITE',
        same: 'SAME',
      }

      /** 場所ごとのIDパラメータ名 */
      const idName = {
        torokubasyo: 'TOROKUBAYO_KO_ID',
        direct: 'AA_ID',
        okiniiri: 'FAVORITE_ID',
      }

      const d = this.selectedItem

      // タブ切替
      const hTab = tabName[d.HIKITORI_PLACE_TYPE]
      const nTab = tabName[d.NOSYA_PLACE_TYPE]
      this.changeActiveTab('HIKITORI', hTab, this.form)
      this.changeActiveTab('NOSYA', nTab, this.form)

      // 引取設定
      const hName =
        hTab === 'DIRECT' && d.HIKITORI_PLACE_REF_ID ? 'AUCTION' : hTab
      const hikitori = setData(d, 'HIKITORI', hName)
      hikitori[idName[d.HIKITORI_PLACE_TYPE]] = d.HIKITORI_PLACE_REF_ID
      this.form.HIKITORI_AA_FLG = Number(d.HIKITORI_AA_FLG)
      this.form[`HIKITORI_${hName}`] = hikitori

      // 納車設定
      if (d.NOSYA_PLACE_TYPE !== 'same') {
        const nName =
          nTab === 'DIRECT' && d.NOSYA_PLACE_REF_ID ? 'AUCTION' : nTab
        const nosya = setData(d, 'NOSYA', nName)
        nosya[idName[d.NOSYA_PLACE_TYPE]] = d.NOSYA_PLACE_REF_ID
        this.form.NOSYA_AA_FLG = Number(d.NOSYA_AA_FLG)
        this.form[`NOSYA_${nName}`] = nosya
      } else {
        this.form.HIKITORI_AA_FLG = Number(d.HIKITORI_AA_FLG)
      }

      this.setHikino()
      this.hikinoSearch()

      this.showDialog_trans = false
    },

    /**
     * 都道府県選択時の処理
     * @param  {string} paramName パラメータ名
     */
    async changePref(paramName) {
      this.form[`${paramName}_SHIKU_CD`] = '' // 市区町村の初期値設定
      this.cities[`${paramName}`] = []
      if (this.form[`${paramName}_TODO_CD`])
        await this.setCities(
          this.form[`${paramName}_TODO_CD`],
          paramName,
          this.cities
        )
      if (this.form[`${paramName}_TYPE`] !== '') {
        this.getRireki(
          this.form.HUM_TANTO_ID,
          this.form[`${paramName}_TODO_CD`],
          this.form[`${paramName}_SHIKU_CD`],
          this.form[`${paramName}_TYPE`]
        )
      }
    },
    /**
     * 市区町村選択時の処理
     * @param  {string} paramName パラメータ名
     */
    async changeCity(paramName) {
      if (this.form[`${paramName}_TYPE`] !== '') {
        this.getRireki(
          this.form.HUM_TANTO_ID,
          this.form[`${paramName}_TODO_CD`],
          this.form[`${paramName}_SHIKU_CD`],
          this.form[`${paramName}_TYPE`]
        )
      }
    },

    /** 引取先情報を納車先にコピーする */
    copyHtoN() {
      const hTab =
        this.form.ACTIVE_HIKITORI_TAB === 'DIRECT' && this.form.HIKITORI_AA_FLG
          ? 'AUCTION'
          : this.form.ACTIVE_HIKITORI_TAB
      this.form[`NOSYA_${hTab}`] = _.cloneDeep(this.form[`HIKITORI_${hTab}`])
    },

    /** 引取オークション表示フラグを設定する */
    setHikitoriAaFlg(tabName) {
      if (tabName === 'MASTER') this.form.HIKITORI_AA_FLG = 0
      else this.isHikitoriGetAaFlg[tabName] = true
    },

    /** 納車オークション表示フラグを設定する */
    setNosyaAaFlg(tabName) {
      if (tabName === 'MASTER') this.form.NOSYA_AA_FLG = 0
      else this.isNosyaGetAaFlg[tabName] = true
    },

    /** 引取先の選択した値を受け取る */
    onSelectedHikitori(item, dataKbn) {
      this.form[`HIKITORI_${dataKbn}`] = item
      this.setHikiSelectedAaCd()
    },

    /** 引取先の選択リセット */
    onHikitoriReset(dataKbn) {
      this.form[`HIKITORI_${dataKbn}`] = _.cloneDeep(HIKINO_SAKI)
    },

    /** 引取先のバリデーション結果を受け取る */
    onHikitoriInvalid(result, dataKbn) {
      this.isHikitoriValid[dataKbn] = false
      this.hikitoriInvalid[dataKbn] = result
    },

    /** 引取ロード完了 */
    onHikitoriLoaded(isLoading, dataKbn) {
      this.hikitoriIsLoading[dataKbn] = isLoading
    },

    /** 引取先検索完了 */
    onHikitoriSearched(dataKbn) {
      this.hikitoriIsSearch[dataKbn] = false
    },

    /** 引取先のオークションフラグを受け取る */
    onHikitoriIsAAflg(isAAFlg, dataKbn) {
      this.isHikitoriGetAaFlg[dataKbn] = false
      if (dataKbn === this.form.ACTIVE_HIKITORI_TAB) {
        this.form.HIKITORI_AA_FLG = isAAFlg
        if (this.isNosyaSame) this.form.NOSYA_AA_FLG = isAAFlg
      }
    },

    /** 引取先のPOS番号を設定する */
    onHikitoriPosBango(val) {
      if (!this.form.HIKITORI_AA_POS_BANGO) {
        this.form.HIKITORI_AA_POS_BANGO = val
      }
    },

    /** 引取先お気に入りフラグ */
    onHikitoriIsOkiniiri(isOkiniiri) {
      this.form.isHikitoriOkiniiri = isOkiniiri
    },

    /** 納車先の選択した値を受け取る */
    onSelectedNosya(item, dataKbn) {
      this.form[`NOSYA_${dataKbn}`] = item
      this.setNosyaSelectedAaCd()
    },

    /** 納車先の選択リセット */
    onNosyaReset(dataKbn) {
      this.form[`NOSYA_${dataKbn}`] = _.cloneDeep(HIKINO_SAKI)
    },

    /** 納車先のバリデーション結果を受け取る */
    onNosyaInvalid(result, dataKbn) {
      this.isNosyaValid[dataKbn] = false
      this.nosyaInvalid[dataKbn] = result
    },

    /** 納車ロード完了 */
    onNosyaLoaded(isLoading, dataKbn) {
      this.nosyaIsLoading[dataKbn] = isLoading
    },

    /** 納車先検索完了 */
    onNosyaSearched(dataKbn) {
      this.nosyaIsSearch[dataKbn] = false
    },

    /** 納車先のオークションフラグを受け取る */
    onNosyaIsAAflg(isAAFlg, dataKbn) {
      this.isNosyaGetAaFlg[dataKbn] = false
      if (dataKbn === this.form.ACTIVE_NOSYA_TAB)
        this.form.NOSYA_AA_FLG = isAAFlg
    },

    /** 納車先のPOS番号を設定する */
    onNosyaPosBango(val) {
      if (!this.form.NOSYA_AA_POS_BANGO) {
        this.form.NOSYA_AA_POS_BANGO = val
      }
    },

    /** 納車先お気に入りフラグ */
    onNosyaIsOkiniiri(isOkiniiri) {
      this.form.isNosyaOkiniiri = isOkiniiri
    },

    /** 引取納車詳細情報を設定する */
    onSetHikiNoDetail(val) {
      if (val) {
        this.isHikiNoDetailInvalid = false
        this.form = _.merge(this.form, val)
      } else this.isHikiNoDetailInvalid = true
      this.isGetHikiNoDetail = false
    },

    /** 選択した引き取り先オークオークションコードを設定する */
    setHikiSelectedAaCd() {
      let tabName = this.form[`ACTIVE_HIKITORI_TAB`]
      if (tabName === 'DIRECT') {
        tabName = 'AUCTION'
      }
      this.selectedHikiAaCd = this.form[`HIKITORI_${tabName}`].AA_CD
    },

    /** 選択した納車先オークオークションコードを設定する */
    setNosyaSelectedAaCd() {
      let tabName = this.form[`ACTIVE_NOSYA_TAB`]
      if (tabName === 'DIRECT') {
        tabName = 'AUCTION'
      }
      this.selectedNosyaAaCd = this.form[`NOSYA_${tabName}`].AA_CD
    },

    /** 登録済みの場所に特別料金がある状態で、直接編集タブを表示した際にアラートを表示する */
    specialRateAlert(hikino) {
      if (this.isSpecialRate[hikino]) {
        // alert('お客様用の特別料金を適用するには「登録済みの場所」から住所を選択してください')
        this.isShowSpecialRateAlert = true
      }
    },
  },

  created() {
    // 輸送区分がない場合は発注ホーム画面に遷移
    if (this.$route.params.yusoKbn === undefined) {
      return this.$router.push({ name: 'OrderIndex' })
    }

    const params = _.cloneDeep(this.$route.params)
    if (params.form) this.form = this.formDefaultMerge(params.form)

    // 編集する場合
    if (params.isFromHistoryEdit) {
      this.form.isFromHistoryEdit = true
      this.form._isFromHistoryEdit = true
    } else if (params.form) {
      if (params.form.isFromHistoryEdit) this.form.isFromHistoryEdit = true
    }
  },

  mounted() {
    const params = _.cloneDeep(this.$route.params)
    // 編集する場合
    if (params.isFromHistoryEdit) {
      this.form.ID = params.data.navi_jyuchu.ID
      this.setEdit(params.data.navi_jyuchu)
      delete params.data.navi_jyuchu
      this.form.syaryos = [params.data]

      // 車両画面から戻ったとき
    } else if (params.form) {
      this.setHikino()

      // 通常遷移
    } else {
      // 初期セレクトタブを設定
      if (this.isLease) {
        this.changeActiveTab('HIKITORI', 'DIRECT', this.form)
      }

      // 初期値設定
      // const today = this.getToday()
      // this.form.HIKITORI_AA_KAISAI_BI = today
      // this.form.NOSYA_AA_KAISAI_BI = today
    }

    // 引納検索開始
    this.hikinoSearch()

    this.form.MEIHEN_FLG = params.yusoKbn
    this.form.JYUCYU_SHIKI_CD = Store.state.user.data.JYUCYU_SHIKI_CD
    this.form.HUM_TANTO_ID = Store.state.user.data.ID
    this.getRireki(this.form.HUM_TANTO_ID)

    if (this.form.isNosyaSame) this.changeActiveTab('NOSYA', 'SAME', this.form)
    this.isSetHikiNoDetail = true
  },

  watch: {
    'form.HIKITORI_AA_FLG'(val) {
      if (this.isNosyaSame) this.form.NOSYA_AA_FLG = val
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.section-wrapper
  background: $baseGrayColor
  padding: 1%
.card-body
  background-color: $baseGrayColor
.md-tabs
  background-color: $baseGrayColor
.history-btn
  width: 170px
  font-size: 18px
  @include sp
    width: 150px
    font-size: 16px
.row-width
  width: 47.4%
.exchange-alt
  width: 30px
  height: 30px
  color: #fff
  position: absolute
  margin-left: -2.5%
  @include sp
    margin-left: -6.5%
.exchange-btn
  @extend .base-btn
  font-size: 18px
  width: 20%
  border-color: white !important
  @include sp
    width: 80%
section#order-place,
section#order-remember
  table
    margin: 0
    th
      background: $baseBlueColor
      color: #fff
      width: 32%
    td
      width: 68%
      background: #fff
</style>



// WEBPACK FOOTER //
// src/components/order/Transport.vue